module.exports = __webpack_public_path__ + "img/about_yx.ac7fdf81.jpg";